// extracted by mini-css-extract-plugin
module.exports = {"root":"fire-debris-removal-page_root__6_Nc_"};